import { Directions, IBaseUser, IUser } from '../../../common';
import {
    ICompanyBaseUsers,
    IDeleteUserMailboxAction,
    IPostConnectUserGmailAction,
    IPostConnectUserOutlookAction,
    ISetMyUserAction,
    ISetPageDirection,
    IUpdateLanguage,
} from './interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
interface IUserSlice {
    myUser: IUser | null;
    companyBaseUsers: Array<IBaseUser>;
    uiState: {
        isMyUserLoading: boolean;
        isPostConnectUserGmailLoading: boolean;
        isPostConnectUserOutlookLoading: boolean;
        isDeleteUserMailboxLoading: boolean;
        pageDiraction: Directions;
    };
}

const initialState: IUserSlice = {
    myUser: null,
    companyBaseUsers: [],
    uiState: {
        isMyUserLoading: false,
        isPostConnectUserGmailLoading: false,
        isPostConnectUserOutlookLoading: false,
        isDeleteUserMailboxLoading: false,
        pageDiraction: Directions.ltr,
    },
};

export const sliceName = 'user';
export const userSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        fetchMyUser: (state) => {
            state.uiState.isMyUserLoading = true;
        },
        setMyUser: (state, action: PayloadAction<ISetMyUserAction>) => {
            state.myUser = action.payload.myUser;
            state.uiState.isMyUserLoading = false;
        },
        fetchMyUserFailed: (state) => {
            state.uiState.isMyUserLoading = false;
        },
        setCompanyBaseUsers: (
            state,
            action: PayloadAction<ICompanyBaseUsers>
        ) => {
            state.companyBaseUsers = action.payload.users;
        },
        setPageDirection: (state, action: PayloadAction<ISetPageDirection>) => {
            state.uiState.pageDiraction = action.payload.direction;
        },
        updateLanguage: (_state, _action: PayloadAction<IUpdateLanguage>) => {},
        postConnectUserGmail: (
            state,
            _action: PayloadAction<IPostConnectUserGmailAction>
        ) => {
            state.uiState.isPostConnectUserGmailLoading = true;
        },
        postConnectUserGmailDone: (state) => {
            state.uiState.isPostConnectUserGmailLoading = false;
        },
        postConnectUserOutlook: (
            state,
            _action: PayloadAction<IPostConnectUserOutlookAction>
        ) => {
            state.uiState.isPostConnectUserOutlookLoading = true;
        },
        postConnectUserOutlookDone: (state) => {
            state.uiState.isPostConnectUserOutlookLoading = false;
        },
        deleteUserMailbox: (
            state,
            _action: PayloadAction<IDeleteUserMailboxAction>
        ) => {
            state.uiState.isDeleteUserMailboxLoading = true;
        },
        deleteUserMailboxDone: (state) => {
            state.uiState.isDeleteUserMailboxLoading = false;
        },
    },
});

export const userActions = userSlice.actions;
export default userSlice.reducer;
